const marker = "home/whatsNew/reload";
const whatsNewReload = {
	clear: () => sessionStorage.removeItem(marker),
	isPending: () => sessionStorage.getItem(marker) === "true",
	mark: () => sessionStorage.setItem(marker, "true")
};
export default whatsNewReload;
